"use strict";

var _taggedTemplateLiteral = require("/usr/local/src/bitcoincom-notary/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    .CalendarMonth {\n      background: ", ";\n      text-align: center;\n      vertical-align: top;\n      -webkit-user-select: none;\n      -moz-user-select: none;\n      -ms-user-select: none;\n      user-select: none;\n      padding: 0 ", "px ", "px !important;\n    }\n    .CalendarMonth_table {\n      border-collapse: collapse;\n      border-spacing: 0;\n    }\n    .CalendarMonth_verticalSpacing {\n      border-collapse: separate;\n    }\n    .CalendarMonth_caption {\n      color: ", ";\n      font-size: 16px;\n      text-align: center;\n      padding-top: ", "px;\n      padding-bottom: ", "px;\n      caption-side: initial;\n    }\n    .CalendarMonth_caption__verticalScrollable {\n      padding-top: ", "px;\n      padding-bottom: ", "px;\n    }\n    .CalendarMonthGrid {\n      background: ", ";\n      text-align: left;\n      z-index: 0;\n    }\n    .CalendarMonthGrid__animating {\n      z-index: 1;\n    }\n    .CalendarMonthGrid__horizontal {\n      position: absolute;\n      left: 0;\n    }\n    .CalendarMonthGrid__vertical,\n    .CalendarMonthGrid__vertical_scrollable {\n      margin: 0 auto;\n    }\n    .CalendarMonthGrid_month__horizontal {\n      display: inline-block;\n      vertical-align: top;\n      min-height: 100%;\n    }\n    .CalendarMonthGrid_month__hideForAnimation {\n      position: absolute;\n      z-index: -1;\n      opacity: 0;\n      pointer-events: none;\n    }\n    .CalendarMonthGrid_month__hidden {\n      visibility: hidden;\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = require("styled-components");

var calendarMonth = function calendarMonth(props) {
  var theme = props.theme;
  var palette = theme.palette,
      spacing = theme.spacing;
  return styled_components_1.css(_templateObject(), palette.background["default"], spacing.unit * 2, spacing.unit * 2, palette.text.secondary, spacing.unit * 2, spacing.unit * 5, spacing.unit * 2, spacing.unit, palette.background["default"]);
};

exports["default"] = calendarMonth;